import { concat, fn, hash } from '@ember/helper';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-explorer';
import Table from 'umg-ember-backend/components/record-explorer/table';
import Toolbar from 'umg-ember-backend/components/record-explorer/toolbar';
import Pagination from 'umg-ember-backend/components/ui/pagination';
import Window from 'umg-ember-backend/components/ui/window';

export default class RecordExplorerForA11yReportComponent extends Component {
  // Defaults
  availableFilters = [
    {
      key: 'status',
      type: 'selectValueLabel',
      options: [0, 1],
    },
  ];

  defaultColumns = [
    'url',
    'violationsA',
    'violationsAA',
    'violationsAAA',
    'violationsTotal',
    'score',
    'status',
    'lastScan',
  ];

  tableColumns = [
    {
      property: 'url',
      sortable: true,
      isMainColumn: true,
      isTruncate: true,
    },
    {
      property: 'violationsA',
      sortable: true,
    },
    {
      property: 'violationsAA',
      sortable: true,
    },
    {
      property: 'violationsAAA',
      sortable: true,
    },
    {
      property: 'violationsTotal',
      sortable: true,
    },
    {
      property: 'score',
      sortable: true,
    },
    {
      property: 'status',
      type: 'translate-value',
    },
    {
      property: 'lastScan',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];

  // Template
  // We need to overwrite the default template, because a11y-report are not allowed to duplicate or delete
  <template>
    <Window
      @isBottombarVisible={{if this.recordsData.length true false}}
      @isLoading={{this.loadRecords.isRunning}}
      @isSeamless={{true}}
      @onBodyScroll={{this.setScrollPosition}}
      @scrollPosition={{this.scrollPosition}}
      {{didInsert this.setOrLoadRecords}}
    >
      <:title>
        {{t (concat 'models.plurals.' this.recordType)}}
      </:title>

      <:toolbar>
        <Toolbar
          @activeColumns={{this.activeColumns}}
          @activeFilters={{this.activeFilters}}
          @availableFilters={{this.availableFilters}}
          @columns={{this.tableColumns}}
          @recordType={{this.recordType}}
          @onAddRecord={{this.addRecord}}
          @onAssignRelation={{@onAssignRelation}}
          @onSearch={{this.search}}
          @onSetFilter={{this.setFilter}}
          @parentRecordType={{@parentRecordType}}
          @searchString={{this.searchString}}
          @selectedRecords={{this.selectedRecords}}
        />
      </:toolbar>

      <:body>
        <Table
          @activeSort={{this.activeSort}}
          @columns={{this.visibleColumns}}
          @records={{this.recordsData}}
          @recordType={{this.recordType}}
          @recordActions={{hash edit=this.loadRecord}}
          @selectedRecords={{this.selectedRecords}}
          @onAssignRelation={{@onAssignRelation}}
          @onUpdateSort={{fn this.setFilter 'sort'}}
          @onSelectRecord={{this.selectRecord}}
        />
      </:body>

      <:bottombar>
        <Pagination
          @pagination={{this.records.meta}}
          @setPage={{this.setPage}}
          @setPageLimit={{fn this.setFilter 'pageSize'}}
        />
      </:bottombar>
    </Window>
  </template>
}
